import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';

export default function SimpleBackdrop() {
  const theme = useTheme();
  const [open] = React.useState(true);

  return (
    <div>
      <Backdrop 
        sx={{ 
          color: theme.palette.primary.contrastText, 
          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)',
          zIndex: 9999999999 
        }} 
        open={open}
      >
        <CircularProgress color="primary" />
      </Backdrop>
    </div>
  );
}
